import getEffectiveStatus from './getEffectiveStatus';

// The accountant's work first, then what's waiting on the client, then the
// earlier steps and what's done
const statusOrder = {
  PREPARING_SUBMISSION: 1,
  READY_TO_FILE: 2,
  READY_FOR_REVIEW: 3,
  AWAITING_APPROVAL: 4,
  AWAITING_INFORMATION: 5,
  OPEN: 6,
  PREPARING: 7,
  SUBMITTED_TO_HMRC: 8,
  CANCELLED: 9,
};

const getFilteredSelfAssessments = (data, { search, status }, currentYear) => {
  const selfAssessments =
    data?.assignedSelfAssessments || data?.allSelfAssessments;

  if (!selfAssessments)
    return { selfAssessmentData: [], pastSelfAssessmentData: [] };

  const sortableData = selfAssessments.map((item) => item);

  const sortedData = sortableData.sort((a, b) => {
    const aOrder = statusOrder[getEffectiveStatus(a)];
    const bOrder = statusOrder[getEffectiveStatus(b)];

    if (aOrder > bOrder) {
      return 1;
    }

    if (aOrder < bOrder) {
      return -1;
    }

    return 0;
  });

  const selfAssessmentData = sortedData.filter(
    (item) =>
      item.taxYear.year === currentYear &&
      (!search ||
        item.user?.name.toLowerCase().includes(search.toLowerCase())) &&
      (!status || getEffectiveStatus(item) === status),
  );

  return selfAssessmentData;
};

export default getFilteredSelfAssessments;
